export var Angles;
(function (Angles) {
    Angles[Angles["East"] = 0] = "East";
    Angles[Angles["SouthEast"] = 45] = "SouthEast";
    Angles[Angles["South"] = 90] = "South";
    Angles[Angles["SouthWest"] = 135] = "SouthWest";
    Angles[Angles["West"] = 180] = "West";
    Angles[Angles["NorthWest"] = 225] = "NorthWest";
    Angles[Angles["North"] = 270] = "North";
    Angles[Angles["NorthEast"] = 315] = "NorthEast";
})(Angles || (Angles = {}));
export var Color;
(function (Color) {
    Color[Color["Red"] = 16711680] = "Red";
    Color[Color["Green"] = 65280] = "Green";
    Color[Color["Blue"] = 255] = "Blue";
    Color[Color["Black"] = 0] = "Black";
    Color[Color["White"] = 16777215] = "White";
    Color[Color["Brown"] = 12597547] = "Brown";
    Color[Color["Yellow"] = 16776960] = "Yellow";
    Color[Color["Sepia"] = 7356948] = "Sepia";
    Color[Color["Gray"] = 8359053] = "Gray";
    Color[Color["Gold"] = 16766720] = "Gold";
    Color[Color["Silver"] = 12632256] = "Silver";
    Color[Color["Bronze"] = 13467442] = "Bronze";
})(Color || (Color = {}));
